export default {
  cart: [],
  count: 0,
  error: false,
  errorMessage: "",
  success: false,
  successMessage: "",
};